module.exports = __webpack_public_path__ + "roomtempo.png?eccfffeff33d32c4b370f78064aa190e";